export const DEFAULT_TIME: string = '9:00';
export const TIME_FORMAT = 'HH:mm';
export const MINUTES_IN_FUTURE = 5;
export const DATE_FORMAT = 'yyyy-MM-dd';

export enum PublishErrorFlagKeys {
	TITLE_IS_BLANK = 'TITLE_IS_BLANK',
	DUPLICATE_TITLE = 'TITLE_EXISTS_IN_SPACE',
}

// It doesn't matter what these shortcut keys are as long as they're all unique.
// These are passed as key props to ShortcutListeners to ensure that
// each ShortcutListener unmounts and remounts
// when rendering similar, but different ShortcutListener components.
export const SHORTCUT_KEYS = {
	PMF1: 'PMF1',
	PMF2: 'PMF2',
	USB1: 'USB1',
	PBWMO1: 'PBWMO1',
	PBWMO2: 'PBWMO2',
	PBWMO3: 'PBWMO3',
	PBWMO4: 'PBWMO4',
	PBWMO5: 'PBWMO5',
};
